import React from 'react';

const IconHelp = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="8" stroke="#808080" strokeWidth="1.5" />
    <path
      d="M9.99507 11.5V10.9675C9.99507 10.2687 10.3608 9.60313 10.9926 9.23706C11.9569 8.67133 12.2894 7.4733 11.7241 6.50823C11.1589 5.54315 9.96182 5.21037 8.99753 5.7761C8.39901 6.14216 8 6.77446 8 7.50658"
      stroke="#808080"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M9.99999 15C10.6075 15 11.1 14.5075 11.1 13.9C11.1 13.2925 10.6075 12.8 9.99999 12.8C9.39248 12.8 8.89999 13.2925 8.89999 13.9C8.89999 14.5075 9.39248 15 9.99999 15Z"
      fill="#808080"
    />
  </svg>
);

export default IconHelp;
